// Ordered list of testimonial ids. The translatable quote/author/affiliation
// for each id lives under the `landing_testimonials.items.<id>` i18n key
// (see public/locales/*/translation.json) and is looked up at render time by
// TestimonialsPage. No photos here — TestimonialCard renders an initials
// badge derived from the author's name instead.
export const TESTIMONIAL_IDS: string[] = [
  "bentzy_stolik",
  "yossi_marrus",
  "levi_wilansky",
  "mendy_kaplan",
  "david_bartel",
  "levi_danow",
  "mendy_kramer",
];
